var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.00031C10.8954 2.00031 10 2.89574 10 4.00031C10 4.55259 9.55228 5.00031 9 5.00031C8.44771 5.00031 8 4.55259 8 4.00031C8 3.99923 8 3.99815 8 3.99707C8.00175 1.78942 9.79195 0.000305176 12 0.000305176C14.2091 0.000305176 16 1.79117 16 4.00031C16 5.75251 14.874 7.23912 13.3091 7.78092C13.186 7.82352 13.0903 7.89045 13.0372 7.94922C13.0114 7.97775 13.0026 7.99548 13 8.00301V9.47662L22.3428 15.9447C24.4195 17.3824 24.1965 20.5199 21.9373 21.6495C21.4759 21.8802 20.9671 22.0003 20.4511 22.0003H3.54803C3.03211 22.0003 2.52327 21.8802 2.06182 21.6495C-0.197369 20.5199 -0.420344 17.3824 1.6564 15.9447L11 9.47603V8.00032C11 6.84781 11.9238 6.14404 12.6547 5.89098C13.4391 5.61942 14 4.87408 14 4.00031C14 2.89574 13.1046 2.00031 12 2.00031ZM11.9996 11.2165L2.79482 17.5891C1.9679 18.1616 2.05668 19.4108 2.95625 19.8606C3.13999 19.9525 3.3426 20.0003 3.54803 20.0003H20.4511C20.6566 20.0003 20.8592 19.9525 21.0429 19.8606C21.9425 19.4108 22.0313 18.1616 21.2043 17.5891L11.9996 11.2165Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLength);
export default __webpack_public_path__ + "static/media/length.299b28e4b434f15f29b16071880bb742.svg";
export { ForwardRef as ReactComponent };